export default __webpack_public_path__ + "static/media/wave.a186c747.png";